module.exports = __webpack_public_path__ + "static/media/machu.64751299.jpeg";